import { Extension } from '@tiptap/core';
import { Plugin } from 'prosemirror-state';
import { TextSelection } from 'prosemirror-state';
import { removeTemplateMarks, TEMPLATE_VALUE } from './TemplateValue';

const isTextSelection = (sel) => sel instanceof TextSelection;

const getMarkRangeAtCursor = ($pos) => {
	const activeMarks = $pos.marks();
	const active = activeMarks.find((m) => m.attrs[TEMPLATE_VALUE]);

	if (!active) return null;

	const parent = $pos.parent;
	const parentStart = $pos.start();

	let from = null;
	let to = null;

	parent.descendants((node, offset) => {
		console.log('handle parent', {
			node,
			offset,
			parent,
			nodeMarks: node?.marks,
			isText: node?.isText,
		});
		if (!node.isText) return;

		const has = !!node.marks?.some((m) => m.attrs[TEMPLATE_VALUE]);
		if (!has) return;

		const nodeFrom = parentStart + offset;
		const nodeTo = nodeFrom + node.nodeSize;

		if (from == null) from = nodeFrom;
		to = nodeTo;
	});

	if (from == null || to == null) return null;

	const pos = $pos.pos;
	if (pos < from || pos > to) return null;

	return { from, to, mark: active };
};

export const TemplateValueTypingGuard = Extension.create({
	name: 'templateValueTypingGuard',

	// addCommands() {
	// 	return {
	// 		insertTemplateContent:
	// 			(content) =>
	// 			({ editor, state, dispatch, view }) => {
	// 				const { selection, storedMarks } = state;

	// 				editor.chain().focus().insertContent(content).unsetMark('customSpan').run();

	// 				return true;
	// 			},
	// 	};
	// },
	addProseMirrorPlugins() {
		return [
			new Plugin({
				props: {
					handleTextInput: (view, from, to, text) => {
						const { state } = view;
						const { selection } = state;

						if (!isTextSelection(selection)) return false;

						const range = getMarkRangeAtCursor(selection.$from);
						if (!range?.mark?.attrs?.[TEMPLATE_VALUE]) return false;

						const tr = state.tr
							.setSelection(TextSelection.create(state.doc, range.to))
							.setStoredMarks([])
							.insertText(text, range.to, range.to);

						view.dispatch(tr);
						return true;
					},
					handlePaste: (view, event) => {
						const { state } = view;
						const { selection } = state;

						if (!isTextSelection(selection)) return false;

						const range = getMarkRangeAtCursor(selection.$from);
						if (!range?.mark?.attrs?.[TEMPLATE_VALUE]) return false;

						const tr = state.tr
							.setSelection(TextSelection.create(state.doc, range.to))
							.setStoredMarks([]);
						view.dispatch(tr);
						return false;
					},
				},
			}),
		];
	},
});
